<template>
  <!-- T4+5 UC13.3/13.4: xác nhận bật "Bắt buộc OTP khi đăng nhập" cho vai trò/nhóm.
       Hiện số user đang được miễn OTP sẽ bị ép setup ở lần đăng nhập kế + vài tên mẫu. -->
  <b-modal
    centered
    hide-footer
    footer-class="border-top-none"
    header-class="border-bottom-none"
    :id="modalId"
    size="md"
    :title="'Xác nhận bật bắt buộc OTP khi đăng nhập'"
  >
    <div class="mandate-otp otp-scope">
      <p class="mb-2">
        Khi bật, <b>{{ count }}</b> người dùng đang được miễn OTP thuộc
        {{ entityLabel }} này sẽ bị <b>bắt buộc thiết lập OTP</b> ở lần đăng nhập kế tiếp.
      </p>
      <p v-if="sampleNames && sampleNames.length" class="mb-2 text-muted">
        Ví dụ: {{ sampleNames.join(", ") }}<span v-if="count > sampleNames.length">, ...</span>
      </p>
      <p v-if="count === 0" class="mb-2 text-muted">
        Hiện không có người dùng miễn OTP nào bị ảnh hưởng. Cấu hình vẫn được lưu để áp cho
        người dùng miễn OTP trong tương lai.
      </p>
    </div>
    <div class="d-flex justify-content-end mt-3">
      <base-button button="Xác nhận" @click="onConfirm()" class="btn btn-main ml-2">
        Xác nhận
      </base-button>
      <base-button button="Hủy" @click="hideModal()" class="btn btn-yellow">
        {{ BO_QUA_BUTTON_LABEL }}
      </base-button>
    </div>
  </b-modal>
</template>

<script>
import { BO_QUA_BUTTON_LABEL } from "@/constants/constants";

export default {
  name: "MandateOtpConfirmModal",
  props: {
    // id modal riêng để 2 form (vai trò/nhóm) không đụng nhau nếu render cùng cây.
    modalId: {
      type: String,
      required: false,
      default: "mandate-otp-confirm-modal",
    },
    // "vai trò" | "nhóm" - hiển thị trong câu cảnh báo.
    entityLabel: {
      type: String,
      required: false,
      default: "đối tượng",
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    },
    sampleNames: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide(this.modalId);
    },
    onConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="scss" scoped>
// Reskin OTP (Phase 4): overlay token. Giữ props (modalId/entityLabel/count/sampleNames) + emit confirm.
.mandate-otp {
  font-family: var(--otp-sans);
  color: var(--otp-ink);
  .text-muted {
    color: var(--otp-muted);
  }
}
</style>
